import createStripeSubscriptionAction from "@actions/createStripeSubscriptionAction"
import RedirectWithSearch from "@components/RedirectWithSearch"
import completePaymentLoader from "@loaders/completePaymentLoader"
import getPricesLoader from "@loaders/getPricesLoader"
import getUserLoader from "@loaders/getUserLoader"
import PaymentCompletionPage from "@pages/checkout/PaymentCompletionPage"
import PaymentPage from "@pages/checkout/PaymentPage"
import PlanReadyPage from "@pages/checkout/PlanReadyPage"
import PlansPage from "@pages/checkout/PlansPage"
import { Outlet } from "react-router-dom"

const checkoutRoutes = [
  {
    element: <Outlet />,
    loader: getUserLoader,
    path: "/checkout",
    children: [
      {
        index: true,
        element: <RedirectWithSearch to="/checkout/plans" />,
      },
      {
        element: <PaymentPage />,
        loader: getUserLoader,
        path: "payment",
      },
      {
        element: <PaymentCompletionPage />,
        loader: completePaymentLoader,
        path: "payment-completion",
      },
      {
        element: <PlanReadyPage />,
        path: "plan-ready",
      },
      {
        action: createStripeSubscriptionAction,
        element: <PlansPage />,
        loader: getPricesLoader,
        path: "plans",
      },
    ],
  },
]

export default checkoutRoutes
